import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=746daa86&scoped=true&"
import script from "./Notfound.vue?vue&type=script&lang=js&"
export * from "./Notfound.vue?vue&type=script&lang=js&"
import style0 from "./Notfound.vue?vue&type=style&index=0&id=746daa86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746daa86",
  null
  
)

export default component.exports